"use client";

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useProcessSecurityGuard } from '@/src/hooks/useProcessSecurity';
import { StepPage } from '@/src/components/pages';
import { ProcessInstanceType } from '@/src/shared/schemas';
import { PageLoader } from '@/src/components/Loaders';

interface SecurityGuardProps {
  processInstance: ProcessInstanceType;
  processInstanceId: string;
  productSlug: string;
}

export default function SecurityGuard({ 
  processInstance, 
  processInstanceId, 
  productSlug 
}: SecurityGuardProps) {
  const [isSecurityChecked, setIsSecurityChecked] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);
  const router = useRouter();

  const handleSecurityViolation = () => {
    console.warn(`🚨 SECURITY VIOLATION: Unauthorized access attempt to process ${processInstanceId}`);
    
    console.log('Security violation details:', {
      processInstanceId,
      productSlug,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      url: window.location.href
    });

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('p');
    router.replace(currentUrl.pathname + currentUrl.search);
  };

  const { validateSession } = useProcessSecurityGuard(processInstanceId, handleSecurityViolation);

  useEffect(() => {
    const securityState = validateSession();
    
    if (securityState.isValid) {
      setHasAccess(true);
    } else {
      setHasAccess(false);
      handleSecurityViolation();
      return;
    }
    
    setIsSecurityChecked(true);
  }, [processInstanceId, validateSession]);

  if (!isSecurityChecked) {
    return (
      <div className="flex h-[calc(100vh_-_344px)] w-full flex-1 items-center justify-center">
        <PageLoader />
      </div>
    );
  }

  if (hasAccess) {
    return (
      <StepPage
        processInstance={processInstance}
        processInstanceId={processInstanceId}
      />
    );
  }

  return (
    <div className="flex h-[calc(100vh_-_344px)] w-full flex-1 items-center justify-center">
      <PageLoader />
    </div>
  );
}
